"use client";

interface PriceSummaryProps {
  price: number;
  attendeeCount: number;
  waitlistedCount?: number;
  isCoveredByTotalAccess?: boolean;
}

export function PriceSummary({
  price,
  attendeeCount,
  waitlistedCount = 0,
  isCoveredByTotalAccess = false,
}: PriceSummaryProps): React.ReactElement {
  const confirmedCount = attendeeCount - waitlistedCount;

  return (
    <div className="space-y-2 text-sm">
      {isCoveredByTotalAccess && (
        <div className="rounded-md bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 px-3 py-2 mb-1">
          <p className="text-xs text-blue-700 dark:text-blue-300">
            Included with your Total Access subscription — no charge for this event.
          </p>
        </div>
      )}
      <div className="flex justify-between">
        <span className="text-muted-foreground">
          {confirmedCount} confirmed &times; ${price.toFixed(2)}
        </span>
        <span className="font-medium">${(price * confirmedCount).toFixed(2)}</span>
      </div>
      {waitlistedCount > 0 && (
        <div className="flex justify-between text-muted-foreground">
          <span>{waitlistedCount} waitlisted</span>
          <span>$0.00</span>
        </div>
      )}
      <div className="border-t border-border pt-2 flex justify-between">
        <span className="font-semibold">Total</span>
        <span className="font-semibold text-base tabular-nums">
          ${(price * confirmedCount).toFixed(2)}
        </span>
      </div>
    </div>
  );
}
